import { computed, onMounted, watch } from 'vue'
import useGet from '../../../core/composables/api/useGet'
import { useRoute } from 'vue-router'
import type { Dialog } from '@/core/models/dialog/dialog'

export const useCoacheeDialog = () => {
  const route = useRoute()

  const coacheeId = computed(() => route.params.id as string)

  const endpoint = computed(() => `coaching/coachee/${coacheeId.value}/dialog`)

  const { data, load, status, reload } = useGet<CoacheeDialog>(endpoint)

  onMounted(() => load())

  watch(coacheeId, () => {
    load()
  })

  return {
    data,
    status,
    reload,
  }
}

export interface CoacheeDialog {
  readonly latestDialog?: Dialog
  readonly conductedDialogs: ReadonlyArray<Dialog>
}
